import { Divider, List, Typography } from '@mui/material';
import { SidebarMenuItem, SidebarMenuItemProps } from './SidebarMenuItem';

export type DividerItem = {
  type: 'divider';
  text?: string;
};

type SidebarMenuProps = {
  items: (SidebarMenuItemProps | DividerItem)[];
  handleClose?: () => void;
  currentPath?: string;
  isPathActive?: (path: string) => boolean;
  onNavigate?: (path: string, fromKeyboard?: boolean) => void;
};

const SidebarMenu = ({
  items,
  handleClose,
  currentPath,
  isPathActive,
  onNavigate,
}: SidebarMenuProps) => {
  return (
    <List component='nav'>
      {items && items.length > 0
        ? items.map((item, index) => {
            if ('type' in item && item.type === 'divider') {
              const key = item.text
                ? `divider_${item.text}`
                : `divider_${index}`;
              return (
                <div key={key}>
                  <Divider sx={{ my: 1 }} />
                  {item.text && (
                    <Typography
                      variant='caption'
                      sx={{
                        px: 2,
                        py: 1,
                        display: 'block',
                        color: 'text.secondary',
                        fontSize: '0.7rem',
                        fontWeight: 600,
                        letterSpacing: '0.5px',
                      }}
                    >
                      {item.text}
                    </Typography>
                  )}
                </div>
              );
            }

            const menuItem = item as SidebarMenuItemProps;
            return (
              <SidebarMenuItem
                key={menuItem.path}
                title={menuItem.title}
                path={menuItem.path}
                icon={menuItem.icon}
                endIcon={menuItem.endIcon}
                childRoutes={menuItem.childRoutes}
                badgeCount={menuItem.badgeCount}
                handleClose={handleClose}
                currentPath={currentPath}
                isPathActive={isPathActive}
                onNavigate={onNavigate}
              />
            );
          })
        : null}
    </List>
  );
};

export { SidebarMenu };
